<template>
  <div class="site">
    <header class="nav">
      <router-link class="nav-logo" to="/">
        <img src="/design-assets/img-852b917d51.png" alt="健康产业观察">
      </router-link>
      <ul class="nav-list">
        <router-link class="nav-item" to="/" exact>首页</router-link>
        <router-link class="nav-item" :class="{ active: isChannel('research') }" to="/articles?channel=research">行业研究</router-link>
        <router-link class="nav-item" :class="{ active: isChannel('case') }" to="/articles?channel=case">品牌案例</router-link>
        <router-link class="nav-item" to="/circle">健观会</router-link>
        <router-link class="nav-item" to="/activities">活动</router-link>
        <a class="nav-item" href="https://www.jianguan.info" target="_blank" rel="noopener">健观奖</a>
      </ul>
      <div class="nav-right">
        <router-link class="btn-search" to="/search" title="搜索">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
        </router-link>
        <router-link v-if="isLogin" class="nav-msg" to="/account/messages" title="消息" aria-label="消息中心">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
          <span v-if="msgUnread > 0" class="nav-msg-dot">{{ msgUnread > 99 ? '99+' : msgUnread }}</span>
        </router-link>
        <div v-if="isLogin" class="acc-drop" v-click-outside="closeMenu">
          <button class="acc-top-user" type="button" @click.stop="toggleMenu">
            <span class="acc-top-ava">{{ avatarChar }}</span>
            <span class="acc-top-name">{{ displayName }}</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="acc-drop-menu" :class="{ show: menuOpen }">
            <div class="acc-drop-hd">
              <div class="acc-drop-ava">{{ avatarChar }}</div>
              <div class="acc-drop-info">
                <div class="acc-drop-name">{{ displayName }}</div>
                <div class="acc-drop-sub">{{ displaySub }}</div>
              </div>
              <span v-if="isVip" class="acc-drop-vip">VIP</span>
            </div>
            <router-link to="/account/profile" @click.native="closeMenu">我的资料 / 名片</router-link>
            <router-link to="/account/activities" @click.native="closeMenu">我的活动</router-link>
            <router-link to="/account/vip" @click.native="closeMenu">我的会员</router-link>
            <router-link to="/account/settings" @click.native="closeMenu">账号设置</router-link>
            <button class="danger" type="button" @click="logout">退出登录</button>
          </div>
        </div>
        <router-link v-else class="btn-login" to="/login">登录 / 注册</router-link>
      </div>
    </header>

    <main>
      <router-view />
    </main>

    <footer class="footer">
      <div class="container">
        <nav class="footer-grid" aria-label="页脚导航">
          <div>
            <div class="footer-logo">
              <img src="/design-assets/img-852b917d51.png" alt="健康产业观察" loading="lazy">
            </div>
            <p class="footer-tagline">报道行业 · 赋能创新 · 引领趋势</p>
            <p class="footer-desc">专注消费大健康领域的垂直产业媒体</p>
          </div>
          <div>
            <div class="footer-h">内容</div>
            <router-link class="footer-link" to="/articles?channel=research">行业研究</router-link>
            <router-link class="footer-link" to="/articles?channel=case">品牌案例</router-link>
            <router-link class="footer-link" to="/activities">活动中心</router-link>
          </div>
          <div>
            <div class="footer-h">健观生态</div>
            <router-link class="footer-link" to="/circle">健观会</router-link>
            <a class="footer-link" href="https://www.jianguan.info" target="_blank" rel="noopener">健观奖</a>
            <router-link class="footer-link" to="/vip">会员体系</router-link>
          </div>
          <div>
            <div class="footer-h">关于</div>
            <router-link class="footer-link" to="/about">关于我们</router-link>
            <router-link class="footer-link" to="/login">注册登录</router-link>
            <router-link class="footer-link" to="/cooperate">商务合作</router-link>
          </div>
          <div>
            <div class="footer-h">联系我们</div>
            <div class="footer-qrs">
              <div class="footer-qr">
                <div class="footer-qr-img"><img src="/design-assets/img-d1a34e4539.jpg" alt="健观公众号二维码" loading="lazy"></div>
                <div class="footer-qr-t">健观公众号</div>
              </div>
              <div class="footer-qr">
                <div class="footer-qr-img"><img src="/design-assets/img-eeacf5965b.jpg" alt="健观会小程序码" loading="lazy"></div>
                <div class="footer-qr-t">健观会小程序</div>
              </div>
              <div class="footer-qr">
                <div class="footer-qr-img"><img src="/design-assets/img-40d554e6fe.jpg" alt="合作咨询二维码" loading="lazy"></div>
                <div class="footer-qr-t">合作咨询</div>
              </div>
            </div>
          </div>
        </nav>
        <div class="footer-copy">
          © Since 2021 健康产业观察 · jianguancn.com ·
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">沪ICP备2025118636号-3</a>
          ·
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">增值电信业务经营许可证：沪B2-20261380</a>
        </div>
      </div>
    </footer>

    <button class="backtop" :class="{ show: showBacktop }" type="button" title="回到顶部" aria-label="回到顶部" @click="toTop">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMyCard } from '@/api/card'
import { getVipStatus } from '@/api/vip'
import { getNotificationSummary } from '@/api/notification'
import { subscribe as subscribeChatSocket, disconnect as disconnectChatSocket } from '@/utils/chatSocket'

export default {
  name: 'SiteLayout',
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.__clickOutside = (e) => {
          if (!el.contains(e.target)) binding.value(e)
        }
        document.addEventListener('click', el.__clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutside)
        delete el.__clickOutside
      }
    }
  },
  data() {
    return {
      showBacktop: false,
      menuOpen: false,
      card: null,
      isVip: false,
      msgUnread: 0,
      msgTimer: null,
      unsubSocket: null
    }
  },
  computed: {
    ...mapGetters(['isLogin']),
    displayName() {
      const c = this.card || {}
      const name = String(c.name || c.nickname || '').trim()
      if (name) return name
      const phone = String(c.phone_masked || c.phone || '').trim()
      if (phone) return phone
      return '个人中心'
    },
    displaySub() {
      const c = this.card || {}
      const co = c.company_short || c.company_full || ''
      const title = c.title || ''
      if (co && title) return co + ' · ' + title
      return co || title || '进入用户中心'
    },
    avatarChar() {
      const n = this.displayName
      return n && n !== '个人中心' ? String(n).charAt(0) : '我'
    }
  },
  watch: {
    isLogin: {
      immediate: true,
      handler(v) {
        if (v) {
          this.loadUser()
          this.refreshMsgUnread()
          this.startMsgPoll()
          this.bindChatSocket()
        } else {
          this.card = null
          this.isVip = false
          this.menuOpen = false
          this.msgUnread = 0
          this.stopMsgPoll()
          this.unbindChatSocket()
          disconnectChatSocket()
        }
      }
    },
    '$route'() {
      if (this.isLogin) this.refreshMsgUnread()
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('focus', this.onWindowFocus)
    this.$root.$on('msg-badge-refresh', this.refreshMsgUnread)
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('focus', this.onWindowFocus)
    this.$root.$off('msg-badge-refresh', this.refreshMsgUnread)
    this.stopMsgPoll()
    this.unbindChatSocket()
  },
  methods: {
    bindChatSocket() {
      if (this.unsubSocket) return
      this.unsubSocket = subscribeChatSocket((ev) => {
        if (!ev) return
        if (ev.type === 'badge' || ev.type === 'message') {
          this.refreshMsgUnread()
        }
      })
    },
    unbindChatSocket() {
      if (this.unsubSocket) {
        this.unsubSocket()
        this.unsubSocket = null
      }
    },
    isChannel(ch) {
      return this.$route.path.indexOf('/articles') === 0 && this.$route.query.channel === ch
    },
    onScroll() {
      this.showBacktop = window.scrollY > 400
    },
    onWindowFocus() {
      if (this.isLogin) this.refreshMsgUnread()
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    },
    startMsgPoll() {
      this.stopMsgPoll()
      this.msgTimer = setInterval(() => {
        if (this.isLogin) this.refreshMsgUnread()
      }, 20000)
    },
    stopMsgPoll() {
      if (this.msgTimer) {
        clearInterval(this.msgTimer)
        this.msgTimer = null
      }
    },
    async refreshMsgUnread() {
      if (!this.isLogin) {
        this.msgUnread = 0
        return
      }
      try {
        const res = await getNotificationSummary()
        this.msgUnread = Number((res && res.unread_total) || 0)
      } catch (e) {
        // 保持上次角标
      }
    },
    async loadUser() {
      try {
        const [card, vip] = await Promise.all([
          getMyCard().catch(() => null),
          getVipStatus().catch(() => null)
        ])
        this.card = card
        this.isVip = !!(vip && (vip.is_vip || vip.active))
      } catch (e) {
        this.card = null
      }
    },
    logout() {
      this.menuOpen = false
      this.stopMsgPoll()
      this.$store.commit('SET_TOKEN', '')
      this.card = null
      this.isVip = false
      this.msgUnread = 0
      this.$router.push('/login')
    }
  }
}
</script>

<style>
/* 依赖 design-from-html.css 的 .nav/.footer；此处仅补 Vue Router 激活态与回到顶部 */
.nav-item.router-link-exact-active,
.nav-item.router-link-active,
.nav-item.active {
  color: #fff;
}
.nav-item.router-link-exact-active::after,
.nav-item.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc((100% - 64px) / 2);
  height: 2px;
  background: var(--pc-accent);
}
/* 文章频道页避免「首页」假高亮：仅 exact 给首页下划线；非首页去掉 path 级 active 下划线 */
.nav-item.router-link-active:not(.router-link-exact-active):not(.active)::after {
  display: none;
}

.nav-msg {
  position: relative;
  width: 36px; height: 36px; border-radius: 50%;
  display: inline-flex; align-items: center; justify-content: center;
  color: rgba(255, 255, 255, .85); border: 1px solid rgba(255, 255, 255, .2);
}
.nav-msg:hover { color: #fff; border-color: #fff; }
.nav-msg svg { width: 16px; height: 16px; }
.nav-msg-dot {
  position: absolute; top: -2px; right: -3px;
  min-width: 15px; height: 15px; padding: 0 4px; border-radius: 8px;
  background: #E5484D; color: #fff; font-size: 10px; font-weight: 600;
  line-height: 15px; text-align: center;
  box-shadow: 0 0 0 2px #030F41;
}

.acc-drop { position: relative; }
.acc-top-user {
  display: inline-flex; align-items: center; gap: 8px; font-size: 13px;
  color: rgba(255, 255, 255, .9); padding: 5px 12px 5px 5px;
  border: 1px solid rgba(255, 255, 255, .25); border-radius: 999px;
  background: none; cursor: pointer; font-family: inherit;
}
.acc-top-user:hover { border-color: #fff; background: rgba(255, 255, 255, .08); }
.acc-top-ava {
  width: 28px; height: 28px; border-radius: 50%;
  background: linear-gradient(135deg, #6C2BD9, #C77DFF); color: #fff;
  font-size: 12px; font-weight: 500;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.acc-top-name {
  max-width: 88px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.acc-drop-menu {
  position: absolute; right: 0; top: calc(100% + 8px); width: 236px;
  background: #fff; border: 1px solid var(--pc-border); border-radius: var(--r-md);
  box-shadow: 0 8px 24px rgba(0, 0, 0, .10); padding: 6px;
  opacity: 0; visibility: hidden; transform: translateY(-6px); transition: all .18s; z-index: 80;
}
.acc-drop-menu.show { opacity: 1; visibility: visible; transform: translateY(0); }
.acc-drop-menu a,
.acc-drop-menu button {
  display: block; width: 100%; text-align: left; font-size: 13px; color: var(--pc-text);
  padding: 9px 12px; border: none; background: none; border-radius: var(--r-sm);
  cursor: pointer; text-decoration: none; font-family: inherit; box-sizing: border-box;
}
.acc-drop-menu a:hover,
.acc-drop-menu button:hover { background: var(--pc-primary-soft); color: var(--pc-primary); }
.acc-drop-menu .danger {
  color: var(--pc-error); border-top: 1px solid var(--pc-border);
  border-radius: 0 0 var(--r-sm) var(--r-sm); margin-top: 4px;
}
.acc-drop-menu .danger:hover { background: rgba(225, 29, 72, .06); color: var(--pc-error); }
.acc-drop-hd {
  display: flex; align-items: center; gap: 10px; padding: 12px;
  margin-bottom: 4px; border-bottom: 1px solid var(--pc-border);
}
.acc-drop-ava {
  width: 40px; height: 40px; border-radius: 50%;
  background: linear-gradient(135deg, #6C2BD9, #C77DFF); color: #fff;
  font-size: 16px; font-weight: 500;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.acc-drop-info { flex: 1; min-width: 0; }
.acc-drop-name { font-size: 14px; font-weight: 600; color: var(--pc-text); }
.acc-drop-sub {
  font-size: 12px; color: var(--pc-text-sub); margin-top: 2px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.acc-drop-vip {
  display: inline-flex; align-items: center; padding: 3px 8px;
  background: linear-gradient(135deg, #6C2BD9, #C77DFF); color: #fff;
  font-size: 10px; font-weight: 700; border-radius: 8px; letter-spacing: .5px; flex-shrink: 0;
}

.backtop {
  position: fixed;
  right: 32px;
  bottom: 36px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  background: linear-gradient(135deg, #030f41, #12277a);
  box-shadow: 0 4px 14px rgba(3, 15, 65, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transform: translateY(8px);
  transition: all 0.25s;
  z-index: 90;
  padding: 0;
}
.backtop.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.backtop:hover { box-shadow: 0 6px 18px rgba(3, 15, 65, 0.4); }
</style>
